const steps = [
    {
        num: "01",
        title: "Échange",
        desc: "On discute de votre projet, de vos besoins, de vos contraintes. Par téléphone, visio ou autour d'un café.",
    },
    {
        num: "02",
        title: "Conception",
        desc: "On définit ensemble les fonctionnalités, l'architecture et le design. Vous validez avant le développement.",
    },
    {
        num: "03",
        title: "Développement",
        desc: "On construit votre application avec des points d'avancement réguliers. Vous suivez chaque étape.",
    },
    {
        num: "04",
        title: "Livraison & suivi",
        desc: "Mise en ligne, formation, et accompagnement continu. On reste disponible pour faire évoluer votre outil.",
    },
];

export function Process() {
    return (
        <section id="methode" className="scroll-mt-20 py-10 px-6">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-3xl sm:text-4xl font-bold text-center text-[#1a3660] mb-4">
                    Notre <span className="text-[#f07020]">méthode</span>
                </h2>
                <p className="text-slate-500 text-center max-w-2xl mx-auto mb-10">
                    Un processus simple et transparent, de l'idée à la mise en production.
                </p>
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {steps.map((s) => (
                        <div key={s.num} className="text-center">
                            <div className="text-5xl font-extrabold text-[#f07020]/30 mb-2">{s.num}</div>
                            <h3 className="text-xl font-bold text-[#1a3660] mb-2">{s.title}</h3>
                            <p className="text-slate-500 text-sm leading-relaxed">{s.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
